const formatKey = (val) => {
    return val
        .replace(/ *\([^)]*\) */g, '_')
        .replace(/>/g, 'gt')
        .replace(/</g, 'lt')
        .replace(/[&\/\\#+()$~%.'*?]/g, '_')
        .replace(/ /g, '_')
        .replace('\u00bd', '')
        .replace(',', '_');
};
export { formatKey };
